import React, { useEffect, useState } from 'react';
import '../fonts/fonts.css';
import './toggleSwitchCase.css';
import './toggleSwitch.css';
import './saveButton.css';
import './loginButton.css';
import './loginButtonOther.css';
import './lastfmModal.css';
import './particles.css';
import './downloadButton.css';
import './donateButton.css';
import './home.css';
import './otherButton.css';
import './footer.css';
import './thisisliterallyjustforthebuttons.css';
import Header from './header';
import titleImage from '../images/titleImage.png';
import grainGif from '../images/grain.gif';
import spotifyLogo from '../images/spotify.png';
import albumifiedLogo from '../images/albumified.png';
import { fetchLastfmTopTracks } from '../services/lastfmService';
import twitterIcon from '../images/twitter.png';
import instagramIcon from '../images/instagram.png';
import facebookIcon from '../images/facebook.png';
import snapchatIcon from '../images/snapchat.png';
import paperPlaneIcon from '../images/paper-plane.png';

function Home({ isLoggedIn, setIsLoggedIn, accessToken, setAccessToken, onLogout }) {
  const [topTracks, setTopTracks] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [timeRange, setTimeRange] = useState('long_term'); // 'long_term' for 12mo, 'medium_term' for 6mo
  const [showLastfmModal, setShowLastfmModal] = useState(false);
  const [lastfmEmail, setLastfmEmail] = useState('');
  const [lastfmError, setLastfmError] = useState('');
  const [dataSource, setDataSource] = useState('spotify'); // 'spotify' or 'lastfm'
  const [lastfmUsername, setLastfmUsername] = useState('');

  useEffect(() => {
    // Particles.js initialization
    if (window.particlesJS) {
      // Initialize particles here if needed
    }
  }, []);

  const fetchTopTracks = async () => {
    setIsLoading(true);
    try {
      const response = await fetch('https://api.spotify.com/v1/me/top/tracks?limit=50&time_range=short_term', {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setTopTracks(data.items);
        generateTreemap(data.items);
      } else if (response.status === 401) {
        // Token expired
        handleLogoutLocal();
      }
    } catch (error) {
      console.error('Error fetching top tracks:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Fetch top tracks when logged in
    if (isLoggedIn && accessToken && topTracks.length === 0) {
      fetchTopTracks();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, accessToken]);

  useEffect(() => {
    // Set up download button click handler
    const downloadBtn = document.getElementById('downloadBtn');
    if (downloadBtn && isLoggedIn) {
      const handleDownload = async () => {
        const captureElement = document.getElementById('treemap-wrapper');
        if (!captureElement) return;
        
        try {
          setIsDownloading(true);
          console.log('Starting download process using html2canvas...');
          
          // Check if html2canvas is available
          if (!window.html2canvas) {
            // Dynamically load html2canvas if not available
            console.log('Loading html2canvas library...');
            const script = document.createElement('script');
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
            document.head.appendChild(script);
            
            await new Promise((resolve, reject) => {
              script.onload = resolve;
              script.onerror = reject;
            });
          }
          
          // Get all background images and store their original opacity
          const backgroundImages = captureElement.querySelectorAll('.album-bg');
          const originalOpacities = [];
          
          // Temporarily set background image opacity to 0.01 for capture
          backgroundImages.forEach((img, index) => {
            originalOpacities[index] = img.style.opacity;
            img.style.opacity = '0.01';
          });
          
          console.log('Capturing treemap with all images...');
          const canvas = await window.html2canvas(captureElement, {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#000000',
            logging: false
          });
          
          // Restore original opacity
          backgroundImages.forEach((img, index) => {
            img.style.opacity = originalOpacities[index];
          });
          
          console.log('✓ Capture complete, converting to image...');
          
          const link = document.createElement('a');
          link.download = 'spotify-top-tracks-treemap.png';
          link.href = canvas.toDataURL('image/png');
          link.click();
          
          console.log('✓ Download complete');
          // alert('✓ Treemap downloaded successfully!');
        } catch (error) {
          console.error('Error generating image:', error);
          alert(`Error: ${error.message}\n\nCheck browser console (F12) for details.`);
        } finally {
          setIsDownloading(false);
        }
      };
      
      downloadBtn.addEventListener('click', handleDownload);
      return () => downloadBtn.removeEventListener('click', handleDownload);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    // Set up time range toggle handler
    const timeRangeSwitch = document.getElementById('switcher-1');
    if (timeRangeSwitch && isLoggedIn) {
      const handleTimeRangeChange = async () => {
        const newTimeRange = timeRangeSwitch.checked ? 'medium_term' : 'long_term';
        setTimeRange(newTimeRange);
        setIsLoading(true);
        try {
          const response = await fetch(`https://api.spotify.com/v1/me/top/tracks?limit=50&time_range=${newTimeRange}`, {
            headers: {
              'Authorization': `Bearer ${accessToken}`
            }
          });
          
          if (response.ok) {
            const data = await response.json();
            setTopTracks(data.items);
            generateTreemap(data.items);
          }
        } catch (error) {
          console.error('Error fetching top tracks:', error);
        } finally {
          setIsLoading(false);
        }
      };
      
      timeRangeSwitch.addEventListener('change', handleTimeRangeChange);
      return () => timeRangeSwitch.removeEventListener('change', handleTimeRangeChange);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, accessToken]);

  useEffect(() => {
    // Set up save playlist button click handler
    const savePlaylistBtn = document.getElementById('save-playlist-button');
    if (savePlaylistBtn && isLoggedIn) {
      const handleSaveClick = () => {
        savePlaylist();
      };
      
      savePlaylistBtn.addEventListener('click', handleSaveClick);
      return () => savePlaylistBtn.removeEventListener('click', handleSaveClick);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, accessToken, topTracks, timeRange]);

  const handleSpotifyLogin = () => {
    const clientId = process.env.REACT_APP_SPOTIFY_CLIENT_ID || 'YOUR_SPOTIFY_CLIENT_ID';
    const redirectUri = process.env.REACT_APP_REDIRECT_URI || window.location.origin;
    const scopes = [
      'user-read-private',
      'user-read-email',
      'user-top-read',
      'playlist-modify-public',
      'playlist-modify-private'
    ];

    const authUrl = `https://accounts.spotify.com/authorize?client_id=${clientId}&response_type=token&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scopes.join(' '))}`;

    window.location.href = authUrl;
  };

  const handleLastLogin = () => {
    setShowLastfmModal(true);
    setLastfmError('');
    setLastfmEmail('');
  };

  const handleLastfmSubmit = async (e) => {
    e.preventDefault();
    setLastfmError('');

    if (!lastfmEmail.trim()) {
      setLastfmError('Please enter a Last.fm username');
      return;
    }

    try {
      setIsLoading(true);
      const tracks = await fetchLastfmTopTracks(lastfmEmail.trim(), 50, 'overall');
      
      if (!tracks || tracks.length === 0) {
        throw new Error('No tracks found. Please check your username and try again.');
      }

      setTopTracks(tracks);
      setLastfmUsername(lastfmEmail.trim());
      setDataSource('lastfm');
      setIsLoggedIn(true);
      setShowLastfmModal(false);
      setLastfmEmail('');
      
      // Generate treemap after a short delay to ensure state is updated
      setTimeout(() => {
        generateTreemap(tracks);
      }, 100);
    } catch (error) {
      console.error('Error fetching Last.fm data:', error);
      setLastfmError(error.message || 'Failed to fetch your Last.fm data. Please check your username and try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleLastfmCancel = () => {
    setShowLastfmModal(false);
    setLastfmEmail('');
    setLastfmError('');
  };

  const handleLogoutLocal = () => {
    setTopTracks([]);
    setDataSource('spotify');
    setLastfmUsername('');
    onLogout();
  };

  const savePlaylist = async () => {
    if (!accessToken || topTracks.length === 0) {
      alert('No tracks to save. Please load your top tracks first.');
      return;
    }

    try {
      console.log('Saving playlist to Spotify...');
      
      // Get user ID
      const userResponse = await fetch('https://api.spotify.com/v1/me', {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      });

      if (!userResponse.ok) {
        throw new Error('Failed to get user info');
      }

      const userData = await userResponse.json();
      const userId = userData.id;

      // Create playlist
      const playlistResponse = await fetch(`https://api.spotify.com/v1/users/${userId}/playlists`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: `Albumify ${new Date().getFullYear()} - ${timeRange === 'medium_term' ? '6 Months' : '12 Months'}`,
          description: 'Your top tracks curated by Albumify',
          public: false
        })
      });

      if (!playlistResponse.ok) {
        throw new Error('Failed to create playlist');
      }

      const playlistData = await playlistResponse.json();
      const playlistId = playlistData.id;

      // Add tracks to playlist
      const trackUris = topTracks.map(track => track.uri);
      
      // Spotify limits to 100 tracks per request, so we need to chunk them
      const chunkSize = 100;
      for (let i = 0; i < trackUris.length; i += chunkSize) {
        const chunk = trackUris.slice(i, i + chunkSize);
        const addResponse = await fetch(`https://api.spotify.com/v1/playlists/${playlistId}/tracks`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            uris: chunk
          })
        });

        if (!addResponse.ok) {
          throw new Error('Failed to add tracks to playlist');
        }
      }

      console.log('Playlist Saved!');
      alert(`Playlist "Albumify ${new Date().getFullYear()}" saved to your Spotify account!`);
    } catch (error) {
      console.error('Error saving playlist:', error);
      alert(`Error saving playlist: ${error.message}`);
    }
  };

  const generateTreemap = (tracks) => {
    const treemapElement = document.getElementById('treemap');
    const switchContainer = document.getElementById('switchContainer');
    const downloadBtn = document.getElementById('downloadBtn');
    
    if (!treemapElement || !window.d3) return;

    // Show controls
    if (switchContainer) switchContainer.style.display = 'block';
    if (downloadBtn) downloadBtn.style.display = 'block';

    // Apply treemap styles
    treemapElement.style.backgroundColor = 'white';
    treemapElement.style.borderRadius = '4px';
    treemapElement.style.width = '100%';
    treemapElement.style.height = '100%';
    treemapElement.style.position = 'relative';
    treemapElement.style.boxSizing = 'border-box';
    treemapElement.style.paddingBottom = '3px';

    const d3 = window.d3;
    const gridSize = treemapElement.clientWidth;
    const minSize = 10;
    const topThreeMinPercent = 0.55;
    const topThreeMaxPercent = 1.3;
    const topThreePercentages = Array(3).fill().map(() => 
      topThreeMinPercent + (topThreeMaxPercent - topThreeMinPercent) * Math.random()
    ).sort((a, b) => b - a);

    const data = {
      name: "Top Tracks",
      children: tracks.map((track, index) => {
        let value;
        if (index < 3) {
          value = gridSize * gridSize * topThreePercentages[index];
        } else {
          value = Math.max(minSize * minSize, (gridSize * gridSize * 0.55) / (tracks.length - 3) * (tracks.length - index));
        }
        
        // Handle both Spotify and Last.fm data formats
        const artistName = typeof track.artist === 'string' 
          ? track.artist 
          : (track.artists && track.artists[0] ? track.artists[0].name : 'Unknown Artist');
        
        const imageUrl = dataSource === 'lastfm'
          ? (track.image || null)
          : (track.album && track.album.images && track.album.images[0] ? track.album.images[0].url : null);
        
        const url = dataSource === 'lastfm'
          ? track.url
          : (track.external_urls ? track.external_urls.spotify : '#');
        
        return {
          name: track.name,
          artist: artistName,
          value: value,
          image: imageUrl,
          url: url,
        };
      })
    };

    const treemap = d3.treemap()
      .size([gridSize, gridSize])
      .paddingLeft(3)
      .paddingRight(3)
      .paddingTop(3)
      .paddingInner(2)
      .round(true)
      .tile(d3.treemapSquarify.ratio(1));

    const root = d3.hierarchy(data)
      .sum(d => d.value)
      .sort((a, b) => b.value - a.value);

    treemap(root);

    const maxY = Math.max(...root.leaves().map(d => d.y1));
    treemapElement.style.height = `${maxY + 3}px`;

    d3.select("#treemap").selectAll("*").remove();

    const nodes = d3.select("#treemap")
      .selectAll(".node")
      .data(root.leaves())
      .enter()
      .append("a")
      .attr("class", "node")
      .attr("href", d => d.data.url)
      .attr("target", "_blank")
      .attr("title", d => `${d.data.name} - ${d.data.artist}`)
      .style("left", d => `${d.x0}px`)
      .style("top", d => `${d.y0}px`)
      .style("width", d => `${Math.max(d.x1 - d.x0, minSize)}px`)
      .style("height", d => `${Math.max(d.y1 - d.y0, minSize)}px`)
      .style("display", "block")
      .style("position", "absolute")
      .style("overflow", "hidden");

    // Add blurred stretched background image to fill entire box
    nodes.append("img")
      .attr("class", "album-bg")
      .attr("src", d => d.data.image)
      .attr("crossorigin", "anonymous")
      .attr("loading", "eager")
      .style("position", "absolute")
      .style("top", "0")
      .style("left", "0")
      .style("width", "100%")
      .style("height", "100%")
      .style("object-fit", "cover")
      .style("object-position", "center")
      .style("filter", "blur(10px)")
      .style("opacity", "0.5")
      .style("pointer-events", "none");

    // Add square foreground album cover (sized to shortest dimension)
    nodes.append("img")
      .attr("class", "album-fg")
      .attr("src", d => d.data.image)
      .attr("crossorigin", "anonymous")
      .attr("loading", "eager")
      .style("position", "absolute")
      .style("object-fit", "cover")
      .style("object-position", "center")
      .style("display", "block")
      .style("pointer-events", "none")
      .each(function(d) {
        const width = Math.max(d.x1 - d.x0, minSize);
        const height = Math.max(d.y1 - d.y0, minSize);
        const size = Math.min(width, height);
        
        d3.select(this)
          .style("width", `${size}px`)
          .style("height", `${size}px`)
          .style("top", `${(height - size) / 2}px`)
          .style("left", `${(width - size) / 2}px`);
      });

    // Add Albumify label to first track
    nodes.filter((d, i) => i === 0)
      .append("div")
      .attr("class", "albumify-label")
      .style("color", "white")
      .style("font-size", "7px")
      .style("width", "100%")
      .style("z-index", "9999")
      .style("font-weight", "bold")
      .style("font-family", "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif")
      .style("padding", "5px")
      .style("backdrop-filter", "blur(1px)")
      .style("border-radius", "3px")
      .style("text-align", "left")
      .style("position", "relative")
      // .html(() => {
      //   const currentYear = new Date().getFullYear();
      //   return ``;
      // });
      // ${currentYear} Albumify Album - Top Songs (12 months)

    console.log('Treemap generated with', tracks.length, 'tracks');
  };

  return (
    <>
      <div className="grain-background" style={{ backgroundImage: `url(${grainGif})` }}></div>
      <Header isLoggedIn={isLoggedIn} onLogout={handleLogoutLocal} onLogin={handleSpotifyLogin} />

      {/* Last.fm Modal */}
      {showLastfmModal && (
        <div className="modal-overlay" onClick={handleLastfmCancel}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Connect Last.fm</h2>
            <p>Enter your Last.fm username to generate your Rewind</p>
            
            <form onSubmit={handleLastfmSubmit}>
              <input
                type="text"
                value={lastfmEmail}
                onChange={(e) => setLastfmEmail(e.target.value)}
                placeholder="Enter your Last.fm username"
                disabled={isLoading}
                autoFocus
              />
              
              {lastfmError && <div className="error-message">{lastfmError}</div>}
              
              <div className="modal-buttons">
                <button 
                  type="submit" 
                  className="modal-button submit"
                  disabled={isLoading}
                >
                  {isLoading ? 'Loading...' : 'Generate Rewind'}
                </button>
                <button 
                  type="button"
                  className="modal-button cancel"
                  onClick={handleLastfmCancel}
                  disabled={isLoading}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {!isLoggedIn && (
        <div className="titleContainer">
          <img className="titleImage" src={titleImage} alt="2025" title="2025" />
          <h1 className="fpHeaderTitle" id="frontpageContent">Rewind</h1>
        
          <h2 className="fpHeader2" id="frontpageContentDesc">
            Albumified's 2025 rewind is here, featuring a downloadable graph and playlist showing your most listened to songs of 2025!</h2>
          <button className="loginButton2 heightFix" id="login-button" onClick={handleSpotifyLogin}>
            <span className="bolduh">Login with Spotify</span>
          </button>
          <button className="loginButton3 heightFix" id="login-button-last" onClick={handleLastLogin}>
            <span className="bolduh">Login with Last.fm</span>
          </button>
        </div>
      )}
      
      {isLoggedIn && (
        <div id="container">
          <div id="treemap-wrapper">
            <div id="treemap-container">
              <div id="treemap"></div>
            </div>
            <div className="spotify-banner">
              {dataSource === 'lastfm' ? (
                <>
                  <span className="banner-logo banner-left" style={{ color: '#fff', fontSize: '14px', fontWeight: 'bold' }}>
                    Last.fm
                  </span>
                  <span className={`banner-year ${isDownloading ? 'downloading' : ''}`}>
                    {lastfmUsername} • {new Date().getFullYear()}
                  </span>
                </>
              ) : (
                <>
                  <img src={spotifyLogo} alt="Spotify" className="banner-logo banner-left" />
                  <span className={`banner-year ${isDownloading ? 'downloading' : ''}`}>
                    {new Date().getFullYear()} • {timeRange === 'medium_term' ? '6mo' : '12mo'}
                  </span>
                </>
              )}
              <img src={albumifiedLogo} alt="Albumified" className="banner-logo banner-right" />
            </div>
          </div>
          
          <button id="downloadBtn" className="topButton" style={{ display: 'none' }}></button>
          
          <div id="switchContainer" style={{ display: 'none' }}>
          <span className="switchCap">
            <span className="switcher switcher-1">
              <input type="checkbox" id="switcher-1" />
              <label htmlFor="switcher-1"></label>
            </span>
          </span>

          <button 
            className="donateButton" 
            onClick={() => window.open('https://buymeacoffee.com/albumified', '_blank')}
            title="Support Albumified on Buy Me a Coffee"
          ></button>
          <div id="save-playlist-button" className="testbutton"></div>
          {/* <div className="saveButton"></div> */}

          <div className="iconCap">
            <a href="https://x.com/">
              <img className="icon icon1" id="twitter" src={twitterIcon} alt="X" title="Twitter X" />
            </a>
            <a href="https://instagram.com/">
              <img className="icon icon2" id="instagram" src={instagramIcon} alt="Instagram" title="Instagram" />
            </a>
            <a href="https://facebook.com/">
              <img className="icon icon3" id="facebook" src={facebookIcon} alt="Facebook" title="Facebook" />
            </a>
            <a href="https://snapchat.com/">
              <img className="icon icon4" ic="snapchat" src={snapchatIcon} alt="Snapchat" title="Snapchat" />
            </a>
          </div>

          <div className="textBoxCap">
            <form id="contactForm">
              <input
                className="nameStyle fontStyle"
                type="text"
                id="name"
                name="name"
                placeholder="Enter Name:"
                required
              />
              <input
                className="emailStyle fontStyle"
                type="email"
                id="email"
                name="email"
                placeholder="Enter Email:"
                required
              />
              <textarea
                className="contentStyle fontStyle2"
                id="message"
                name="message"
                placeholder="Enter Message:"
                required
              ></textarea>
              <button type="submit" className="sendButton1">
                <img src={paperPlaneIcon} alt="Send" title="Send Message" />
              </button>
            </form>
            </div>
          </div>
        </div>
      )}
      
      <p id="albumify-text"></p>
    </>
  );
}

export default Home;

